<template>
  <div class="h-full flex flex-col items-center justify-center p-4">
    <div class="w-full max-w-sm">
      <div class="flex justify-center items-center mb-8">
        <svgicon name="logo" class="w-24 h-24 text-gray-lightest"/>
      </div>
      <form-login class="box w-full rounded-lg"></form-login>
    </div>
    <div class="mt-10 text-primary-lighter">
        © {{ year }} Pistor par <a class="hover:text-primary-lightest" href="http://latr.me">Lambert Traccard</a>
    </div>
  </div>
</template>


<script>
/* globals moment */
import FormLogin from '../components/auth/LoginForm.vue';

export default {
  components: { FormLogin },

  computed: {
    year() {
      return moment().format('YYYY');
    },
  },
};
</script>